<template>

    <!-- Page Sidebar Ends-->
    <div class="page-body">
        <PageTitle  title="Dustbins" />
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header" v-if="userDetails.emprole==999">
                            <button class="btn btn-secondary" type="button" data-bs-toggle="modal"
                                data-original-title="test" data-bs-target="#dustbinAdd">Add Dustbin</button>
                        </div>
                        <div class="card-body badge-spacing">
                            <div class="table-responsive custom-scrollbar">
                                <table class="table display" id="basic-1">
                                    <thead>
                                        <tr>
                                            <th>Sr.</th>
                                            <th>NP Name</th>
                                            <th>Title</th>
                                            <th>Description</th>
                                            <th>Slave ID</th>
                                            <th>Lattitude</th>
                                            <th>Longitude</th>
                                            <th>Fill Limit</th> 
                                            <th>Current Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr  v-for="(item ,index)  in dustbins" :key="item.id" >
                                            <td>{{index+1}}</td>
                                            <td>{{item.np_name}}</td>
                                            <td>{{item.title}}</td>
                                            <td>{{item.description}}</td>
                                            <td>{{item.slaveid}}</td>
                                            <td>{{item.lat}}</td>
                                            <td>{{item.lng}}</td> 
                                            <td>{{item.fill_limit}}</td> 
                                            <td>{{item.current_status}}</td> 
                                            <td>
                                                <ul class="action">
                                                    <!--<li class="edit" @click="edit_dustbin(item.id)"><i class="icon-pencil-alt"></i></li>-->
                                                    <li class="delete" @click="remove_dustbin(item.id)"><i class="icon-trash"></i></li>
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- footer   start-->
     <div class="modal fade"  v-if="userDetails.emprole==999" id="dustbinAdd" tabindex="-1" role="dialog" aria-labelledby="dustbinAdd"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Add Dustbin</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper ">
                        <div class="col-sm-12">
                            <div class="row g-3">
                                 <div class="col-md-12 position-relative">
                                       <label class="form-label">Select Nagarpalika</label>
                                        <select class="form-select" required="" v-model="dustbin.nagarpalikaid"> 
                                              <option  v-for="(item ,index)  in nagarpalikas" :key="item.id" :value="item.id">{{item.name}}</option>     
                                    </select>
                                    </div> 
                                <div class="col-md-12 position-relative">
                                    <label class="form-label">Title</label>
                                    <input class="form-control" type="text" v-model="dustbin.title"
                                        placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-12 position-relative">
                                    <label class="form-label">Description</label>
                                    <input class="form-control" type="text" v-model="dustbin.description"
                                        placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-12 position-relative">
                                    <label class="form-label">Slave ID</label>
                                    <input class="form-control" type="text" v-model="dustbin.slaveid"
                                        placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-12 position-relative">
                                    <label class="form-label">Lattitude</label>
                                    <input class="form-control" type="number" v-model="dustbin.lat"
                                        placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-12 position-relative">
                                    <label class="form-label">Longitude</label>
                                    <input class="form-control" type="number" v-model="dustbin.lng"
                                        placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-12 position-relative">
                                    <label class="form-label">Fill Limit</label>
                                    <input class="form-control" type="number" v-model="dustbin.fill_limit"
                                        placeholder="Type Here..." required="">
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12">
                        <button class="btn btn-primary" @click="save_dustbin">Add dustbin</button>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>
<style scoped>
    .row > *{
            margin-top: 0;
    }
</style>
<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue';
import ModalsPart from '@/components/Modals.vue';
import axios from 'axios';
const config = {
            headers: {
               "Content-Type": "application/x-www-form-urlencoded"
            },
            responseType: 'json'
         };
export default {
    name: 'Dustbin', 
    components: {
        PageTitle, ModalsPart
    }, mounted() {
        this.getBasics();

    }, data() {
        return {
            userDetails:{'emprole':0,'isMainAdmin':0,'empdept':0},
            dustbins: [],
            nagarpalikas: [],
            dustbin:{"title":'',"description":'',"slaveid":'',"lat":'',"lng":'',"fill_limit":'','nagarpalikaid':0}
        }
    },
    methods: {
        updateData(value) {
            this.dustbins = value;
        },
        getBasics() {
            var self = this;
            axios.post('getDustbins', config).then(function (response) {
                self.userDetails = response.data.userDetails; 
                self.dustbins = response.data.dustbins; 
                self.nagarpalikas = response.data.nagarpalikas; 
                window.scrollTo(0, 0);
            });
        },
        remove_dustbin(id) {
            var self = this;
            axios.post('removedustbin', {dustbin_id:id}).then(function (response) {
                self.dustbins = response.data.dustbins; 
                window.scrollTo(0, 0);
            });
        },
        
            save_dustbin() {
                var self = this; 
                axios.post('addDustbin', self.dustbin)
                    .then(response => {
                        var msg = response.data.msg;
                        var isSuccess = response.data.status;
                        self.dustbins = response.data.dustbins;
                        self.$swal(msg);
                        if (isSuccess == 1) {
                            $("#dustbinAdd").modal("toggle"); 
                        }
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
            },
       
    }
}
</script>
